import * as z from 'zod';
import { REGEXES } from '@/constants/regexes';

// * 中文字（unicode u4e00 - u9fa5a）、英文字大小寫、數字、常見符號（&.,'*!-）+ 不允許有連續空白
export const nameValidator = (options: { fieldName: string }) =>
  z
    .string()
    .min(1, { message: `請輸入${options.fieldName}` })
    .regex(/^[\u4e00-\u9fa5a-zA-Z0-9]/, {
      message: '請以中文字或半形英數字開頭',
    })
    .regex(REGEXES.textWithCommonSymbols, {
      message: `僅能包含中文字、半形英數字、半形空格及符號（&.,'!-）；請勿輸入連續空格或以空格結尾`,
    });

export const passwordValidator = z
  .string()
  .min(8, { message: '密碼長度至少為 8 個字符' })
  .max(20, { message: '密碼長度不能超過 20 個字符' })
  .regex(/[A-Za-z]/, { message: '密碼請包含至少一個半形英文字' })
  .regex(/[0-9]/, { message: '密碼請包含至少一個半形數字' })
  .regex(/[@%!#$?]/, { message: '密碼請包含至少下列任一個特殊符號（@%!#$?）' });

export const passwordMatchValidator = (options: { password: string; confirmPassword: string }) =>
  options.password === options.confirmPassword;
